'use client';
import styled from 'styled-components';
import { colors } from '@/styles';

export const UserHeader = styled.div``;

// export const OrganizationImage = styled.div`
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   border: 1px solid ${colors.secondary.lightGray3};
//   border-radius: 10px;
//   overflow: hidden;
//   width: 100px;
//   aspect-ratio: auto 100 / 100;
//   img {
//     width: 100%;
//     height: 100%;
//     object-fit: cover;
//   }
// `;
